import React from "react";
import useDocumentTitle from "../../hooks/useDocumentTitle";
import { getTranslation } from "../../i18n/translations";
import "./ErrorPage.css";

const ErrorPage = ({ lang = "es" }) => {
  const t = getTranslation(lang).errorPage;
  useDocumentTitle(t.documentTitle);

  return (
    <div className="error-container">
      <div className="error-card">
        <div className="error-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="8" x2="12" y2="12" />
            <line x1="12" y1="16" x2="12.01" y2="16" />
          </svg>
        </div>

        <h1 className="error-title">{t.title}</h1>

        <p className="error-message">{t.message}</p>

        <div className="error-actions">
          <a
            href="https://www.immunotec.com"
            className="btn btn-primary"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t.returnHome}
          </a>
          <a
            href="https://www.immunotec.com/contact"
            className="btn btn-secondary"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t.contactSupport}
          </a>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;
